import axios from 'axios';

export default {
  async loadConfiguration(context) {
    await axios
      .get(`${context.rootState.apiBaseURL}/AS/ApplicationSetting/GetByType/5`)
      .then((response) => {
        if (response.data) {
          let configs = response.data.map((conf) => {
            return { title: conf.title, value: conf.value };
          });
          context.commit('setConfiguratoins', configs);
        }

        // context.commit('setRefreshTokenData', {
        //   token: response.data.token,
        //   refreshToken: response.data.refreshToken,
        // });
        // localStorage.setItem('token', response.data.token);
        // localStorage.setItem('refreshToken', response.data.refreshToken);
        // axios.defaults.headers.common = {
        //   Authorization: `Bearer ${response.data.token}`,
        // };
      });
  },
};
